import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSiteSettings } from './SiteSettingsContext';

const CANONICAL_BASE = 'https://salonidesigns.com';

const PAGE_META = {
  home: {
    path: '/',
    fallbackTitle: 'Buy Premium Handcrafted Rakhi Online | Saloni Designs',
    fallbackDescription:
      'Shop premium handcrafted Rakhi & Lumba collections online at Saloni Designs. Authentic designs. Shipping across India.',
  },
  shop: {
    path: '/shop',
    fallbackTitle: 'Shop Premium Rakhi & Lumba Collections Online | Saloni Designs',
    fallbackDescription:
      'Browse our premium handcrafted Rakhi and Lumba collections online. Authentic Indian jewelry, shipped across India.',
  },
  contact: {
    path: '/contact',
    fallbackTitle: 'Contact Saloni Designs | Rakhi & Lumba — Ahmedabad',
    fallbackDescription:
      'Contact Saloni Designs for custom Rakhi and Lumba orders. Call, email, WhatsApp, or visit Ahmedabad.',
  },
  about: {
    path: '/about',
    fallbackTitle: 'About Saloni Designs | Handcrafted Rakhi & Lumba',
    fallbackDescription:
      'Learn about Saloni Designs — handcrafted Rakhi and Lumba rooted in tradition, made with care in Ahmedabad.',
  },
};

/**
 * @param {{ page: 'home'|'shop'|'contact'|'about', children?: React.ReactNode }} props
 */
export default function PageSeoHelmet({ page, children }) {
  const { settings: site } = useSiteSettings();
  const meta = PAGE_META[page] || PAGE_META.home;
  const prefix = `seo_${page}`;

  const title = String(site[`${prefix}_title`] || '').trim() || meta.fallbackTitle;
  const description =
    String(site[`${prefix}_description`] || '').trim() || meta.fallbackDescription;
  const ogImage = String(site[`${prefix}_og_image`] || '').trim();
  const canonical = `${CANONICAL_BASE}${meta.path}`;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonical} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />
        {ogImage ? <meta property="og:image" content={ogImage} /> : null}
      </Helmet>
      {children}
    </>
  );
}
